import React, { useState, createContext, useContext } from "react";
import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../firebase";

const TranslationContext = createContext();

const translations = {
  en: {
    search: "Search",
    searchPlaceholder: "Search...",
    switchLanguage: "Switch Language",
    live: "LIVE",
    account: "Account",
    logout: "Logout",
    signIn: "Sign In",
    signUp: "Sign Up",
    loading: "Loading...",
    error: "Error occurred",
    home: "Home",
    about: "About",
    contact: "Contact",
    settings: "Settings",
    heroDescription: "Your Source For Live Digital Broadcasts. Powered By",
    homeInstruction: "Select a thumbnail below to watch digital broadcasts",
    footerPowered: "Powered by",
    footerWebsite: "iSiLIVE Website",
    footerWebsite2: "Previous Archives",
    footerAdmin: "Admin",
    shortDescription: "Short description:",
    noShortDescripton: "No short description available",
    longDescription: "Long description:",
    noLongDescription: "No long description available",
    videos: "Videos",
    currentlyPlaying: "Currently playing:",
    views: "Views:",
    broadcastInterest: "Interested in broadcasting your event?",
    broadcastEmailCta: "Email events@isilive.ca",
    notFound: "404 - Page Not Found",
    notFoundSorry: "Sorry, the page you're looking for doesn't exist.",
    notFoundGoHome: "Go Home",
    noVideosAvailable: "No Videos Available",
    previousVideosPrompt: "Looking for previous videos?",
    clickHere: "Click Here",
    accessOldWebsite: "to access the old website.",
    loginTitle: "Sign In",
    loginError: "Invalid Username or Password",
    email: "Email",
    password: "Password",
    rememberMe: "Remember Me",
    resetPassword: "Reset Password",
    newToiSiLive: "New to iSiLIVE?",
    signingInNote:
      "*Signing in is not required and is used for saving series, password access and helps us know how many people use the site",
    signupTitle: "Sign Up",
    emailAlreadyInUse: "Email already in use",
    failedToCreateAccount: "Failed to create an account",
    alreadySubscribed: "Already subscribed to iSiLIVE?",
    sendResetEmail: "Send Password Reset Email",
    rememberedPasswordQuestion: "Remembered your password?",
    checkInbox: "Check your inbox for further instructions",
    forbiddenTitle: "Forbidden: Access Denied",
    yourUidIs: "Your UID is:",
    hello: "Hello",
    accountBannerAlt: "iSiLIVE Live Banner",
    accountSeeVideos: "See live and archived videos on the",
    accountSavedFavourites: "or view your saved favourites below",
    unknownSeries: "Unknown Series",
    confirmRevokeAccess:
      "Are you sure you want to remove access to this series?",
    failedRemoveAccess: "Failed to remove access. Please try again.",
    loadingAuthorizedSeries: "Loading authorized series...",
    noPasswordSeriesAccess:
      "You don't have access to any password-protected series.",
    passwordSeriesAccess: "Password-Protected Series Access",
    passwordProtected: "Password Protected",
    removeAccess: "Remove Access",
    pleaseLoginToSaveSeries: "Please log in to save a series",
    myFavourites: "My Favourites",
    noSavedFavourites:
      "No saved favourites found. If just added, please refresh.",
  },
  fr: {
    search: "Rechercher",
    searchPlaceholder: "Rechercher...",
    switchLanguage: "Changer de langue",
    live: "EN DIRECT",
    account: "Compte",
    logout: "Déconnexion",
    signIn: "Se connecter",
    signUp: "S'inscrire",
    loading: "Chargement...",
    error: "Une erreur est survenue",
    home: "Accueil",
    about: "À propos",
    contact: "Contact",
    settings: "Paramètres",
    heroDescription:
      "Votre source pour les diffusions numériques en direct. Propulsé par",
    homeInstruction:
      "Sélectionnez une miniature ci-dessous pour regarder les diffusions numériques",
    footerPowered: "Propulsé par",
    footerWebsite: "Site Web iSiLIVE",
    footerWebsite2: "Archives précédentes",
    footerAdmin: "Admin",
    shortDescription: "Description courte:",
    noShortDescripton: "Aucune courte description disponible",
    longDescription: "Description longue:",
    noLongDescription: "Aucune longue description disponible",
    videos: "Vidéos",
    currentlyPlaying: "Lecture en cours :",
    views: "Vues :",
    broadcastInterest: "Intéressé à diffuser votre événement?",
    broadcastEmailCta: "Écrivez à events@isilive.ca",
    notFound: "404 - Page non trouvée",
    notFoundSorry: "Désolé, la page que vous recherchez n'existe pas.",
    notFoundGoHome: "Retour à l'accueil",
    noVideosAvailable: "Aucune vidéo disponible",
    previousVideosPrompt: "Vous cherchez des vidéos précédentes ?",
    clickHere: "Cliquez ici",
    accessOldWebsite: "pour accéder à l'ancien site.",
    loginTitle: "Se connecter",
    loginError: "Nom d'utilisateur ou mot de passe invalide",
    email: "Courriel",
    password: "Mot de passe",
    rememberMe: "Se souvenir de moi",
    resetPassword: "Réinitialiser le mot de passe",
    newToiSiLive: "Nouveau sur iSiLIVE?",
    signingInNote:
      "*La connexion n'est pas requise et est utilisée pour sauvegarder les séries, l'accès par mot de passe et nous aide à savoir combien de personnes utilisent le site",
    signupTitle: "S'inscrire",
    emailAlreadyInUse: "Courriel déjà utilisé",
    failedToCreateAccount: "Échec de la création d'un compte",
    alreadySubscribed: "Déjà abonné à iSiLIVE?",
    sendResetEmail: "Envoyer l’e-mail de réinitialisation",
    rememberedPasswordQuestion: "Vous vous souvenez de votre mot de passe ?",
    checkInbox:
      "Vérifiez votre boîte de réception pour la suite des instructions",
    forbiddenTitle: "Accès interdit : accès refusé",
    yourUidIs: "Votre UID :",
    hello: "Bonjour",
    accountBannerAlt: "Bannière en direct iSiLIVE",
    accountSeeVideos: "Regardez les vidéos en direct et archivées sur la",
    accountSavedFavourites: "ou consultez vos favoris enregistrés ci-dessous",
    unknownSeries: "Série inconnue",
    confirmRevokeAccess:
      "Êtes-vous sûr de vouloir supprimer l'accès à cette série ?",
    failedRemoveAccess:
      "Échec de la suppression de l'accès. Veuillez réessayer.",
    loadingAuthorizedSeries: "Chargement des séries autorisées...",
    noPasswordSeriesAccess:
      "Vous n'avez accès à aucune série protégée par mot de passe.",
    passwordSeriesAccess: "Accès aux séries protégées par mot de passe",
    passwordProtected: "Protégé par mot de passe",
    removeAccess: "Supprimer l'accès",
    pleaseLoginToSaveSeries:
      "Veuillez vous connecter pour enregistrer une série",
    myFavourites: "Mes favoris",
    noSavedFavourites:
      "Aucun favori enregistré. Si vous venez d'en ajouter, veuillez actualiser.",
  },
};

export const TranslationProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    return localStorage.getItem("language") || "en";
  });

  const setLanguage = (lang) => {
    setCurrentLanguage(lang);
    localStorage.setItem("language", lang);
  };

  const t = (key) => translations[currentLanguage][key] || key;

  const functions = getFunctions(app, "us-central1");
  const translateOnceFn = httpsCallable(functions, "translateOnce");

  const translateText = async (text, targetLang) => {
    if (!text || targetLang === "en") return text;
    try {
      const res = await translateOnceFn({ text, to: targetLang, source: "en" });
      return res?.data ?? text;
    } catch (e) {
      console.error("translateOnce failed:", e);
      return text;
    }
  };

  const translateBatch = async (arr, targetLang) => {
    if (!Array.isArray(arr) || !arr.length) return arr;
    try {
      const res = await translateOnceFn({
        text: arr,
        to: targetLang,
        source: "en",
      });
      return Array.isArray(res?.data) ? res.data : arr;
    } catch {
      return arr;
    }
  };

  const value = {
    currentLanguage,
    setLanguage,
    t,
    translateText,
    translateBatch,
  };

  return (
    <TranslationContext.Provider value={value}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslation = () => {
  const context = useContext(TranslationContext);
  if (!context) {
    throw new Error("useTranslation must be used within a TranslationProvider");
  }
  return context;
};
